import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IEssayTheme } from '../../../core/models/essay';

interface EssayState {
  theme: IEssayTheme | null;
  setTheme: (theme: IEssayTheme) => void;
  resetThemeCourse: () => void;
}

export const useThemeStore = create<EssayState>()(
  persist(
    (set) => ({
      theme: null,
      setTheme: (theme: IEssayTheme) => set({ theme: theme }),
      resetThemeCourse: () => set({ theme: null })
    }),
    {
      name: 'essay-course-theme'
    }
  )
);
